import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

/* =========================
   USER PAGES
========================= */
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import GoldTrading from "./pages/GoldTrading";
import BtcTrading from "./pages/BtcTrading";

/* =========================
   ADMIN PAGES
========================= */
import AdminLogin from "./admin/pages/Login";
import AdminDashboard from "./admin/pages/Dashboard";
import Users from "./admin/pages/Users";
import UserDetails from "./admin/pages/UserDetails";
import Deposits from "./admin/pages/Deposits";
import Investments from "./admin/pages/Investments";
import Withdrawals from "./admin/pages/Withdrawals";
import LevelIncome from "./admin/pages/LevelIncome";

export default function App() {
  return (
    <BrowserRouter>

      <Routes>

        {/* =========================
            USER ROUTES
        ========================= */}

        <Route
          path="/"
          element={<Landing />}
        />

        <Route
          path="/login"
          element={<Login />}
        />

        <Route
          path="/register"
          element={<Register />}
        />

        <Route
          path="/forgot-password"
          element={<ForgotPassword />}
        />

        <Route
          path="/reset-password/:token"
          element={<ResetPassword />}
        />

        <Route
          path="/dashboard"
          element={<Dashboard />}
        />

        {/* =========================
            GOLD DEMO TRADING
        ========================= */}

        <Route
          path="/gold-trading"
          element={<GoldTrading />}
        />

        <Route
          path="/btc-trading"
          element={<BtcTrading />}
        />

        {/* =========================
            ADMIN ROUTES
        ========================= */}

        <Route
          path="/admin/login"
          element={<AdminLogin />}
        />

        <Route
          path="/admin/dashboard"
          element={<AdminDashboard />}
        />

        <Route
          path="/admin/users"
          element={<Users />}
        />

        <Route
          path="/admin/user-details/:userId"
          element={<UserDetails />}
        />

        <Route
          path="/admin/deposits"
          element={<Deposits />}
        />

        <Route
          path="/admin/investments"
          element={<Investments />}
        />

        <Route
          path="/admin/withdrawals"
          element={<Withdrawals />}
        />

        <Route
          path="/admin/level-income"
          element={<LevelIncome />}
        />

        {/* =========================
            404
        ========================= */}

        <Route
          path="*"
          element={
            <Navigate
              to="/"
              replace
            />
          }
        />

      </Routes>

    </BrowserRouter>
  );
}
